import React, { type ComponentProps } from 'react';
import { Platform, StyleSheet } from 'react-native';

import { CustomNavigationHeader } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemNavigationHeader = (props: Props) => {
  const { closeAccessibilityLabel, onClose, scrollOffsetSV, title } = props;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <CustomNavigationHeader.Container
      buttonsReservedSpace="left-and-right"
      palette="oatmeal"
      safeAreaEdges={SAFE_AREA_EDGES}
      scrollOffsetSV={scrollOffsetSV}
    >
      <CustomNavigationHeader.Content style={styles.content} scrollOffsetSV={scrollOffsetSV}>
        <CustomNavigationHeader.Text numberOfLines={1} style={styles.title} textAlignment="center">
          {title}
        </CustomNavigationHeader.Text>
      </CustomNavigationHeader.Content>

      <CustomNavigationHeader.Button.Right
        accessibilityLabel={closeAccessibilityLabel}
        name="IconClose"
        onPress={onClose}
      />
    </CustomNavigationHeader.Container>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SAFE_AREA_EDGES: ComponentProps<typeof CustomNavigationHeader.Container>['safeAreaEdges'] =
  Platform.OS === 'android' ? ['top'] : [];

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  content: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    flex: 0,
    width: '100%',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  closeAccessibilityLabel: string;
  onClose: () => void;
  scrollOffsetSV: ComponentProps<typeof CustomNavigationHeader.Container>['scrollOffsetSV'];
  title: string;
};
